import { initStep1 } from './step1'
import { initStep2 } from './step2'
import { initStep3 } from './step3'
// import { initThankYouPage } from './thankYouPage'

export function initCart() {
    initGlobalCart()
    initStep1()
    initStep2()
    initStep3()
    // initThankYouPage()

    // document.addEventListener('ShoptetDOMCartContentLoaded', initGlobalCart)
}

function initGlobalCart() {
    cartGlobalTextChanges()
    moveCartElements()
    checkoutSidebar()
    limitSidebarMaxTopPos()
    wrapCartContent()
}

function cartGlobalTextChanges() {
    // $('.back-to-shop').text(_t('cart.backToShop'))
}

function wrapCartContent() {
    if ($('.id--15').length) return
    $('.content-inner').wrapInner('<div id="cart-wrapper"></div>')
}

export function moveCartElements() {
    const nextStepBack = $('.next-step-back').clone()
    const target = $('.id--9').length > 0 ? '.cart-inner' : '#checkoutContent'

    nextStepBack.appendTo(target).wrap('<div class="next-step-back"></div>')
}

/*
 * Nastavuje aktuální pozici sidebaru na základě výšky obsahu a sidebaru.
 * Maže styl top pokud je sidebar větší než obsah.
 * Nastavuje top pozici na scroll až do maximální možné top pozice, což je velikost obsahu
 */
function setCheckBarPos() {
    if ($('.id--15').length) return

    let checkoutContentHeight = $('#checkoutContent').height()
    const checkoutSidebarHeight = $('#checkoutSidebar').height()
    let maxTopPos = Math.max(0, checkoutContentHeight - checkoutSidebarHeight)
    let topValue = parseInt(shoptet.checkout.$checkoutSidebar.css('top'), 10)

    if (topValue <= 0) {
        shoptet.checkout.$checkoutSidebar.removeAttr('style')
    }

    if (topValue > maxTopPos) {
        shoptet.checkout.$checkoutSidebar.css('top', `${maxTopPos}px`)
    }
}

/*
 *Omezuje maximální absolutní top pozici sidebaru při posuvu stránky.
 *zachycuje událost scroll a aktualizuje pozici bočního panelu pomocí funkce 'setCheckBarPos'.
 */
function limitSidebarMaxTopPos() {
    if ($('.id--15').length) return
    if ($('.id--9').length) return

    const originalHandleWithSidebar = shoptet.checkout.handleWithSidebar
    $(window).unbind('scroll')
    $(window).bind('scroll', function () {
        shoptet.abilities.feature.fixed_header = true
        originalHandleWithSidebar.apply(this, arguments)
        requestAnimationFrame(function () {
            setCheckBarPos()
        })
    })
}

// Předělává názvy produktů na správný formát a přidává názvy značek a případně informaci o tom, že produkt je dárek zdarma.
function checkoutSidebar() {
    const cartProducts = $('#checkoutSidebar .order-summary-item')
    const giftProducts = $('#checkoutSidebar .gift-items')
    cartProducts.each(function () {
        const productName = $(this).find('.cart-item-name')
        productName.wrap('<div class="product-name"></div>')
    })
    if (giftProducts.length) {
        giftProducts.each(function () {
            const productName = $(this).find('.cart-item-name')
            productName.before(`<div class="product-gift">Dárek zdarma!</div>`)
        })
    }
}
